import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["percentageField", "fixedField"]

  toggleType(event) {
    const isFixed = event.target.value === "fixed"
    this.percentageFieldTarget.classList.toggle("hidden", isFixed)
    this.fixedFieldTarget.classList.toggle("hidden", !isFixed)
  }
}
